import { render, staticRenderFns } from "./filename.vue?vue&type=template&id=35ba57b4&scoped=true"
import script from "./filename.vue?vue&type=script&lang=js"
export * from "./filename.vue?vue&type=script&lang=js"
import style0 from "./filename.vue?vue&type=style&index=0&id=35ba57b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba57b4",
  null
  
)

export default component.exports